// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"564":"d3de5196","624":"d3de5196","751":"d3de5196","779":"d3de5196","880":"d3de5196"}[chunkId] + ".chunk.css";
};